<template>
 <!-- Page Footer-->
    <footer class="section footer-modern">
        <div class="footer-modern-body section-xl">
			<div class="container">
				<div class="row row-40 row-md-50 justify-content-xl-between">
					<div class="col-sm-6 col-lg-3 wow fadeInRight" data-wow-delay=".1s">
						<div class="footer-brand" style="margin-bottom: 30px;">
							<router-link to="/">
								<img src="/assets/images/Logo_Horizontal.jpg" alt="CakeGurus" style="max-width: 220px; border-radius: 8px;">
							</router-link>
						</div>
						<h5 class="footer-modern-title">Quick Links</h5>
						<ul class="footer-modern-list footer-modern-list-2 d-sm-inline-block d-md-block">
							<li><a href="/">Home</a></li>
							<li><a href="/our-menu">Our Menu</a></li>
							<li><a href="/custom-cake-category">Custom Cakes</a></li>
							<li><a href="/about-us">About Us</a></li>
							<li><a href="/contact-us">Contact Us</a></li>
							<li><a href="/careers">Careers</a></li>
						</ul>
					</div>

					<div class="col-sm-6 col-lg-3 wow fadeInRight" data-wow-delay=".2s">
						<h5 class="footer-modern-title">CakeGurus Truganina</h5>
						<ul class="contacts-creative">
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-map-marker"></span></div>
									<div class="unit-body">Shop 16, 211 Leakes Rd, Truganina VIC 3029</div>
								</div>
							</li>
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-phone"></span></div>
									<div class="unit-body"><a href="tel:0423644818">0423 644 818</a>, <a href="tel:0393941681">03 9394 1681</a></div>
								</div>
							</li>
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-email-outline"></span></div>
									<div class="unit-body"><a href="mailto:info@cakegurus.com.au">info@cakegurus.com.au</a></div>
								</div>
							</li>
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-timer"></span></div>
									<div class="unit-body">All 7 Days 10 am - 9 pm</div>
								</div>
							</li>
						</ul>
						<ul class="list-inline list-social-3 list-inline-sm">
							<li><a class="icon mdi mdi-facebook icon-xxs" href="https://www.facebook.com/cakegurus" target="_blank"></a></li>
							<li><a class="icon mdi mdi-instagram icon-xxs" href="https://www.instagram.com/cakegurus/" target="_blank"></a></li>
							<li><a class="icon mdi mdi-google-plus icon-xxs" href="https://cakegurus.business.site" target="_blank"></a></li>
						</ul>
					</div>

					<div class="col-sm-6 col-lg-3 wow fadeInRight" data-wow-delay=".3s">
						<h5 class="footer-modern-title">CakeGurus Cranbourne</h5>
						<ul class="contacts-creative">
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-map-marker"></span></div>
									<div class="unit-body">14 Lurline Street, Cranbourne VIC 3977</div>
								</div>
							</li>
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-phone"></span></div>
									<div class="unit-body"><a href="tel:0412401771">0412 401 771</a>, <a href="tel:0359953490">03 5995 3490</a></div>
								</div>
							</li>
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-email-outline"></span></div>
									<div class="unit-body"><a href="mailto:info@cakegurus.com.au">info@cakegurus.com.au</a></div>
								</div>
							</li>
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-timer"></span></div>
									<div class="unit-body">All 7 Days 11 am - 8 pm</div>
								</div>
							</li>
						</ul>
						<ul class="list-inline list-social-3 list-inline-sm">
							<li><a class="icon mdi mdi-facebook icon-xxs" href="https://www.facebook.com/CakegurusCranbourne" target="_blank"></a></li>
							<li><a class="icon mdi mdi-instagram icon-xxs" href="https://www.instagram.com/cakegurus.cranbourne" target="_blank"></a></li>							
						</ul>
					</div>

					<div class="col-sm-6 col-lg-3 wow fadeInRight" data-wow-delay=".4s">
						<h5 class="footer-modern-title">CakeGurus <br> Epping</h5>
						<ul class="contacts-creative">
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-map-marker"></span></div>
									<div class="unit-body">Shop 3, 145 Gateway boulevard, Epping, VIC - 3076</div>
								</div>
							</li>
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-phone"></span></div>
									<div class="unit-body"><a href="tel:0416300460">0416 300 460</a></div>
								</div>
							</li>
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-email-outline"></span></div>
									<div class="unit-body"><a href="mailto:info@cakegurus.com.au">info@cakegurus.com.au</a></div>
								</div>
							</li>
							<li>
								<div class="unit unit-spacing-sm flex-column flex-md-row">
									<div class="unit-left"><span class="icon mdi mdi-timer"></span></div>
									<div class="unit-body">6 Days 11 am - 8 pm <br>(Monday Closed)</div>
								</div>
							</li>
						</ul>
						<ul class="list-inline list-social-3 list-inline-sm">
							<li><a class="icon mdi mdi-facebook icon-xxs" href="https://www.facebook.com/share/1Cr52u1suc/?mibextid=wwXIfr" target="_blank"></a></li>
							<li><a class="icon mdi mdi-instagram icon-xxs" href="https://www.instagram.com/cakegurus.epping?igsh=aGNzdWdxNHdkOGNn" target="_blank"></a></li>
						</ul>
					</div>
				</div>
			</div>
        </div>
        <div class="footer-modern-panel">
			<div class="container">
				<div class="row align-items-center justify-content-between">
					<div class="col-md-3 text-center text-md-left mb-4 mb-md-0">
						<img src="/assets/images/ssl_logo.png" alt="Positive SSL" style="max-width: 110px;">
					</div>
					<div class="col-md-6 text-center mb-4 mb-md-0">
						<p class="rights"><span>&copy;&nbsp;</span><span class="copyright-year"></span><span> All Rights Reserved by CakeGurus</span></p>
					</div>
					<div class="col-md-3 text-center text-md-right">
						<div class="payment-methods mb-2">
							<img src="/assets/images/visa.png" alt="Visa" style="max-height: 35px; border-radius: 4px; margin: 0 3px;">
							<img src="/assets/images/master_card.png" alt="MasterCard" style="max-height: 35px; border-radius: 4px; margin: 0 3px;">
							<img src="/assets/images/paypal.png" alt="PayPal" style="max-height: 35px; border-radius: 4px; margin: 0 3px;">
							<img src="/assets/images/amarican_express.png" alt="American Express" style="max-height: 35px; border-radius: 4px; margin: 0 3px;">
						</div>
						<p style="font-size: 11px; margin: 0; color: #777777;">We do not store Credit/Debit Card details.</p>
					</div>
				</div>
			</div>
        </div>
    </footer>
</template>